import { LinearGradient } from "expo-linear-gradient";
import { useState } from "react";
import { View } from "react-native";
import { FlatList } from "react-native-gesture-handler";
import KeyboardDismissView from "src/components/KeyboardDismissView";
import OpacityView from "src/components/OpacityView";
import native from "src/constants/native";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { paddingLarge, paddingMedium, paddingSmall } from "src/styles/spacing";
import { AnimatePresence, useSafeArea } from "src/swsh-native";
import SearchModalHeader from "./components/SearchModalHeader";
import renderSearchRow from "./helpers/renderSearchRow";
import searchKeyExtractor from "./helpers/searchKeyExtractor";
import useSearchContent from "./hooks/useSearchContent";
import useSearchModalDim from "./hooks/useSearchModalDim";

const GradientSpacing = paddingLarge;
const SearchModal = () => {
	const modalDim = useSearchModalDim();
	const [search, setSearch] = useState("");
	const { content } = useSearchContent(search);
	const [size, setSize] = useState<{
		width: number;
		height: number;
	} | null>();
	const safeArea = useSafeArea();
	const { theme } = useStyle();

	return (
		<OpacityView style={[modalDim]} entering={!native}>
			<SearchModalHeader onSearchChange={setSearch} />
			<View
				style={{
					marginTop: paddingSmall,
					flex: 1,
				}}
				onLayout={(event) => {
					setSize({
						width: event.nativeEvent.layout.width,
						height: event.nativeEvent.layout.height,
					});
				}}
			>
				{!!size && (
					<>
						<AnimatePresence>
							<OpacityView
								style={{
									position: "absolute",
									width: size.width,
									height: size.height,
								}}
								key={Array.isArray(content) ? "List" : content.variant}
								duration={200}
							>
								{Array.isArray(content) ? (
									<>
										<FlatList
											keyboardDismissMode="on-drag"
											data={content}
											renderItem={renderSearchRow}
											keyExtractor={searchKeyExtractor}
											contentContainerStyle={{
												paddingTop: GradientSpacing,
												paddingBottom: safeArea.bottom + paddingMedium,
											}}
										/>
										<LinearGradient
											style={{
												position: "absolute",
												top: 0,
												width: "100%",
												height: GradientSpacing,
											}}
											colors={[color.BackgroundModal[theme], "transparent"]}
										/>
									</>
								) : (
									<KeyboardDismissView
										containerStyle={{
											width: size.width,
											height: size.height,
										}}
										style={{
											width: "100%",
											height: "100%",
										}}
									>
										{renderSearchRow({
											item: content,
										})}
									</KeyboardDismissView>
								)}
							</OpacityView>
						</AnimatePresence>
					</>
				)}
			</View>
		</OpacityView>
	);
};
export default SearchModal;
